var _rect, _circle, _path, _path2, _path3, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    role: "img",
    "aria-label": "Java logo badge",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    rx: 22,
    fill: "#f7fbff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 96,
    r: 52,
    fill: "#e6f2ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 44c22 18-28 30-4 48 17 13 39 21 4 48",
    fill: "none",
    stroke: "#e76f00",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 126c30 15 78 8 92-8",
    fill: "none",
    stroke: "#0074bd",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 145c37 14 83 7 105-11",
    fill: "none",
    stroke: "#0074bd",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 92,
    fontFamily: "Arial, sans-serif",
    fontSize: 36,
    fontWeight: 800,
    fill: "#0b2f55"
  }, "JAVA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 126,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#52657c"
  }, "Mock Exam")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.e899f83beb9226b80f203993f2a48c5d.svg";
export { ForwardRef as ReactComponent };